<template>
    <client-page class="wrap--sub">
        <!-- 서브비주얼 -->
        <sub-visual :visual="'전자제조지원센터'"></sub-visual>
        <div class="tab-list--primary-wrap">
            <ul class="tab-list tab-list--primary">
                <li><router-link to="/about" class="button">센터개요</router-link></li>
                <li class="on"><router-link to="/about/equipments" class="button">장비소개</router-link></li>
                <li><router-link to="/about/location" class="button">오시는 길</router-link></li>
                <!-- <li><router-link to="/about/business" class="button">사업개요</router-link></li> -->
            </ul>
        </div>

        <section class="section">
            <v-container>

                <section class="page-section  page-section--first">
                    <tit-primary
                    sc="equipment"
                    tit="전자보드와 목업을 지원할 수 있는 전문장비를 보유하고 있습니다."
                    titTxt="전문 엔지니어가 제품개발과 생산을 지원합니다.">
                    </tit-primary>

                    <h4 class="tit--sm bar-txt">
                        장비구성
                    </h4>

                    <div class="border-top border-2 border-color-black page-text color-grey">
                        <sub-list-primary
                        tit="전자제조장비"
                        sc="전자부품실장(SMT) 및 수삽부품 조립라인 (총 3라인) 40여종"
                        spacing="min-w-120px min-w-lg-160px mr-md-18 mr-xl-48" />
                        <sub-list-primary
                        tit="목업장비"
                        sc="기구설계, 기구제작, 시제품 외형(목업)제작 지원장비 10여종"
                        spacing="min-w-120px min-w-lg-160px mr-md-18 mr-xl-48" />
                        <sub-list-primary
                        tit="측정평가/디버깅/AS장비"
                        sc="전자 실험 및 측정평가, 신뢰성검사, 부품 리페어 장비 10여종"
                        spacing="min-w-120px min-w-lg-160px mr-md-18 mr-xl-48" />
                        <sub-list-primary
                        tit="사후관리/마케팅"
                        sc="공용AS조립룸, 스튜디오, "
                        spacing="min-w-120px min-w-lg-160px mr-md-18 mr-xl-48">
                            <template #content>
                                <v-btn text large class="pa-4" height="auto" href="https://kea-editor-blacksmith.uxi.kr" target="_blank">
                                    <span> 제품정보지원 플랫폼 </span>
                                    <v-icon small class="ml-4"> mdi-open-in-new </v-icon>
                                </v-btn>
                            </template>
                        </sub-list-primary>
                    </div>
                </section>

                <section class="page-section">
                    <h4 class="tit--sm bar-txt">
                        주요장비
                    </h4>
                    <sub-card-list tit="전자제조장비" className="mb-50 mb-lg-80">
                        <v-row justify="center" class="row--y-large"> 
                            <v-col cols="6" md="3">
                                <sub-image-card image="/images/sub/about/equipments/s2-img1-1.jpg" tit="전자부품실장라인(2라인)" />
                            </v-col>
                            <v-col cols="6" md="3">
                                <sub-image-card image="/images/sub/about/equipments/s2-img1-2.jpg" tit="전자보드조립라인(1라인)" />
                            </v-col>
                            <v-col cols="6" md="3">
                                <sub-image-card image="/images/sub/about/equipments/s2-img1-3.jpg" tit="수삽부품 조립라인" />
                            </v-col>
                            <v-col cols="6" md="3">
                                <sub-image-card image="/images/sub/about/equipments/s2-img1-4.jpg" tit="레이저 마커" />
                            </v-col>
                            <v-col cols="6" md="3">
                                <sub-image-card image="/images/sub/about/equipments/s2-img1-5.jpg" tit="부품검사기(X-ray)" />
                            </v-col>
                            <v-col cols="6" md="3">
                                <sub-image-card image="/images/sub/about/equipments/s2-img1-6.jpg" tit="디버깅" />
                            </v-col>
                            <v-col cols="6" md="3">
                                <sub-image-card image="/images/sub/about/equipments/s2-img1-7.jpg" tit="계측기기" />
                            </v-col>
                            <v-col cols="6" md="3">
                                <sub-image-card image="/images/sub/about/equipments/s2-img1-8.jpg" tit="수삽" />
                            </v-col>
                        </v-row>
                    </sub-card-list>
                    <sub-card-list tit="목업장비" className="mb-50 mb-lg-80">
                        <v-row justify="center" class="row--y-large"> 
                            <v-col cols="6" md="3">
                                <sub-image-card image="/images/sub/about/equipments/s2-img2-1.jpg" tit="산업용 3D 프린터(SLA)" />
                            </v-col>
                            <v-col cols="6" md="3">
                                <sub-image-card image="/images/sub/about/equipments/s2-img2-2.jpg" tit="산업용 3D 프린터(FDM)" />
                            </v-col>
                            <v-col cols="6" md="3">
                                <sub-image-card image="/images/sub/about/equipments/s2-img2-3.jpg" tit="산업용 3D 스캐너" />
                            </v-col>
                        </v-row>
                    </sub-card-list>
                    <sub-card-list tit="측정평가/디버깅장비">
                        <v-row justify="center" class="row--y-large"> 
                            <v-col cols="6" md="3">
                                <sub-image-card image="/images/sub/about/equipments/s2-img3-1.jpg" tit="회로설계 툴" />
                            </v-col>
                            <v-col cols="6" md="3">
                                <sub-image-card image="/images/sub/about/equipments/s2-img3-2.jpg" tit="항온항습기" />
                            </v-col>
                            <v-col cols="6" md="3">
                                <sub-image-card image="/images/sub/about/equipments/s2-img3-3.jpg" tit="부품 리웍스테이션" />
                            </v-col>
                        </v-row>
                    </sub-card-list>
                </section>

                <section class="page-section page-section--last">
                    <h4 class="tit--sm bar-txt">
                        장비사용문의
                    </h4>
                    <v-card elevation="0" color="grey-light" rounded>
                        <div class="pa-20 pa-md-30 pa-lg-40">
                            <v-row justify="center" align="center" class="row--x-large">
                                <v-col cols="auto">
                                    <v-row align="center" justify="center">
                                        <v-col cols="auto">
                                            <div class="icon-wrap">
                                                <i class="icon icon-tel"></i>
                                            </div>
                                        </v-col>
                                        <v-col cols="auto">
                                            <h4 class="tit--sm">
                                                02-6388-6192
                                            </h4>
                                        </v-col>
                                    </v-row>
                                </v-col>
                                <v-col cols="auto">
                                    <v-btn to="/rental/equipments" large rounded color="primary" elevation="0" class="min-w-120px min-w-lg-200px">
                                        장비 예약 바로가기
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </div>
                    </v-card>
                </section>

            </v-container>
        </section>

    </client-page>
</template>

<script>
import SubVisual from "@/components/client/sub/sub-visual.vue";
import ClientPage from "@/pages/client/templates/ClientPage.vue";
import AboutBusiness from "@/components/client/sub/about-business/about-business.vue";
import TitPrimary from "@/components/client/dumb/tit-primary.vue";
import SubListPrimary from "@/components/client/sub/sub-list-primary.vue";
import SubIconItemRounded from "@/components/client/sub/sub-icon-item--rounded.vue";
import SubTextCard from "@/components/client/sub/sub-text-card.vue";
import SubCardList from "@/components/client/sub/sub-card-list.vue";
import SubImageCard from "@/components/client/sub/sub-image-card.vue";
export default {
    components: {
        SubVisual,
        ClientPage,
        AboutBusiness,
        TitPrimary,
        SubListPrimary,
        SubIconItemRounded,
        SubTextCard,
        SubCardList,
        SubImageCard,
    },
    data() {
        return {
            tab: null,
        };
    },
};
</script>

<style lang="scss" scoped>
.icon-wrap{
    width: 60px;
    height: 60px;
    background-color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    >i{
        display: flex;
    }
}
@media (min-width:576px){
}
@media (min-width:768px){
}
@media (min-width:1024px){
    .icon-wrap{
        width: 80px;
        height: 80px;
    }
}
@media (min-width:1200px){
}

</style>
